import styled, { css } from "styled-components";

export const CategoryListContainer = styled.div`
	background-color: rgba(255, 255, 255, 0.95);
	left: 0;
	right: 0;
	z-index: 1000;
	padding: 15px 0;
	border-bottom: 1px solid #eee;
	bottom: -272px;
	position: absolute;
	border-top: 1px solid #eee;
	display: none;
	height: 272px;
`;

export const CategoryContainer = styled.div`
	height: 67px;
	width: 1200px;
	margin: auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const CategoryBox = styled.div`
	max-width: 750px;
	&:hover ${CategoryListContainer} {
		display: block;
	}
`;

export const CategoryContent = styled.div`
	width: 100%;
	overflow: hidden;
	white-space: nowrap;
	overflow-x: scroll;
`;

export const CategoryListContent = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	padding: 10px;
`;

export const CategoryItem = styled.div`
	height: 67px;
	line-height: 67px;
	position: relative;
	display: inline-block;
	padding-right: 40px;
	a {
		color: #333333;
		font-size: 14px;
	}
	${(props) => {
		if (props.isActive)
			return css`
				&::after {
					content: "";
					display: inline-block;
					height: 3px;
					background-color: var(--themeColor);
					width: calc(100% - 40px);
					bottom: 0;
					left: 0;
					position: absolute;
				}
			`;
	}}
`;

// 搜索框的样式
export const SearchContent = styled.div`
	display: flex;
	position: relative;
	input {
		outline: none;
		border: 1px solid #e6e6e6;
		border-radius: 2px 0 0 2px;
		height: 24px;
		padding: 5px 12px;
		width: 176px;
		font-size: 14px;
	}
`;
export const SearchIcon = styled.div`
	cursor: pointer;
	height: 36px;
	border-radius: 0px 2px 2px 0px;
	background: #333333;
	width: 48px;
	display: flex;
	justify-content: center;
	align-items: center;
	img {
		height: 20px;
		width: 20px;
	}
`;

export const SelectModal = styled.div`
	position: absolute;
	width: calc(100% - 48px);
	left: 0;
	background-color: rgba(255, 255, 255, 0.95);
	border: 1px solid #ddd;
	top: 36px;
	min-height: 100px;
	max-height: 200px;
	z-index: 1000;
	padding: 10px;
	overflow-y: scroll;
`;

export const SelectItem = styled.div`
	font-size: 12px;
	line-height: 20px;
	cursor: pointer;
	width: 174px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	&:hover {
		color: var(--themeColor);
	}
`;

export const CategoryListName = styled.div`
	font-size: 12px;
	height: 100%;
	border-right: 1px solid #ddd;
	padding: 0 30px;
	a {
		color: #333333;
		display: block;
		min-width: 100px;
		line-height: 26px;
		text-align: left;
		&:hover {
			color: var(--themeColor);
		}
	}
`;

export const CategoryListImage = styled.div`
	height: 100%;
	padding: 0 30px;
	img {
		height: 100%;
	}
`;
